import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpBaseUrlInterceptor } from './http-base-url.interceptor';

export const httpBaseUrlInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpBaseUrlInterceptor, multi: true },
];
